import { TabletMockup } from "./TabletMockup";
import { useLanguage } from "../i18n/LanguageContext";
import { TitleLines } from "../i18n/text";

type FlexPilotSectionProps = {
    onOpenContactForm: () => void;
};

export function FlexPilotSection({ onOpenContactForm }: FlexPilotSectionProps) {
    const { t } = useLanguage();

    return (
        <section className="section flexSection" id="flex">
            <div className="sectionText">
                <p className="eyebrow">{t.flex.eyebrow}</p>

                <h2>
                    <TitleLines lines={t.flex.titleLines} />
                </h2>

                <p className="lead">{t.flex.lead}</p>

                <div className="flexCardGrid">
                    {t.flex.cards.map((card) => (
                        <article className="flexCard" key={card.title}>
                            <span>{card.icon}</span>

                            <div>
                                <h3>{card.title}</h3>
                                <p>{card.text}</p>
                            </div>
                        </article>
                    ))}
                </div>
            </div>

            <div className="pilotVisual">
                <TabletMockup />

                <div className="pilotSteps">
                    <div className="pilotLine" />

                    {t.flex.steps.map((step, index) => (
                        <article className="pilotStep" key={step.title}>
                            <span className="stepNumber">{index + 1}</span>

                            <div>
                                <h3>{step.title}</h3>
                                <p>{step.text}</p>
                            </div>
                        </article>
                    ))}
                </div>
            </div>

            <div className="ctaPanel" id="contacts">
                <div className="ctaIcon">↗</div>

                <div>
                    <h2>{t.flex.ctaTitle}</h2>
                    <p>{t.flex.ctaText}</p>
                </div>

                <div className="ctaButtons">
                    <button className="primaryButton" type="button" onClick={onOpenContactForm}>
                        {t.flex.discussPilot} <span>→</span>
                    </button>

                    <button className="secondaryButton" type="button" onClick={onOpenContactForm}>
                        {t.flex.getPresentation}
                    </button>
                </div>
            </div>
        </section>
    );
}
